// extracted by mini-css-extract-plugin
export default {"wrapper":"price-module--wrapper--WilYM","price":"price-module--price--3E6o0"};